import { styled } from 'styled-components';
import { Row, Col } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import Slider from 'react-slick';
import ScrollAnimation from 'react-animate-on-scroll';

import { ConsultButton } from './ConsultButton';
import Link from './Link';

import img_features_01 from '../assets/img_features_01.png';
import img_features_02 from '../assets/img_features_02.png';
import img_features_03 from '../assets/img_features_03.png';
import img_features_04 from '../assets/img_features_04.png';
import img_features_05 from '../assets/img_features_05.png';
import img_features_pet from '../assets/img_features_pet.png'
import img_download_android from '../assets/img_download_android.png';
import img_download_ios from '../assets/img_download_ios.png';
import img_download_pet from '../assets/img_download_pet.png';
import img_app_icon from '../assets/img_app_icon.png';
import { IOS_DOWNLOAD_URL, ANDROID_DOWNLOAD_URL } from '../data/url';

const FeatureWrapper = styled.div`
    padding: 160px 60px;

    @media screen and (max-width: 768px) {
        padding: 80px 20px;
    }
`;

const Header = styled(Row)`
    color: #1385C8;
    font-size: 56px;
    font-weight: bold;
    line-height: 76px;
    width: fit-content;
    text-align: center;
    position: relative;

    @media screen and (max-width: 768px) {
        font-size: 36px;
        line-height: 48px;
    }
`;

const CarouselWrapper = styled(Row)`
    margin: 100px 0px;

    @media screen and (max-width: 768px) {
        margin: 40px 0px;
    }
`;

const CarouselItem = styled.div`
    display: flex !important;
    flex-direction: column;
    align-items: center;
`;

const ItemHeader = styled.div`
    color: #1385C8;
    font-size: 36px;
    font-weight: bold;
    line-height: 48px;

    @media screen and (max-width: 768px) {
        font-size: 28px;
        line-height: 40px;
    }
`;

const CustomArrow = styled.div<{ style: React.CSSProperties }>`
    ${({ style }) => ({...style})}
    background-color: #45B9AE;
    width: 40px; 
    height: 40px;
    border-radius: 30px;
    text-align: center;
    font-size: 20px;
    color: #FFFFFF;
    display: flex !important;
    justify-content: center;
    align-items: center;
    z-index: 20;
    
    &:before {
        display: none; 
    }

    &:hover {
        color: #FFFFFF;
        background: #45B9AE;
    }
`;

const DownloadWrapper = styled(Row)`
    border-radius: 32px;
    background: linear-gradient(to right, #DCF5F2, #DEEFFF);
    padding: 40px 40px 40px 120px;
    margin-top: 160px;

    @media screen and (max-width: 768px) {
        padding: 40px 24px;
        margin-top: 80px;
    }
`;

const DownloadContent = styled(Col)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &>* {
        margin: 20px 0;
    }

    div { 
        color: #1385C8;
        font-size: 36px;
        font-weight: bold;
        line-height: 48px;
        text-align: center;
    }
`;

const Feature = () => {

    const PrevArrow = (props: {
        className?: string,
        onClick?: React.MouseEventHandler<HTMLDivElement>,
        style?: React.CSSProperties
    }) => (
        <CustomArrow className={props.className} onClick={props.onClick} style={{ ...props.style!, left: '-15px' }} >
            <LeftOutlined/>
        </CustomArrow>
    );

    const NextArrow = (props: {
        className?: string,
        onClick?: React.MouseEventHandler<HTMLDivElement>,
        style?: React.CSSProperties
    }) => (
        <CustomArrow className={props.className} onClick={props.onClick} style={{ ...props.style!, right: '-15px' }} >
            <RightOutlined/>
        </CustomArrow>
    );

    return (
        <FeatureWrapper id='feature'>
            <ScrollAnimation animateIn='fadeIn' animateOnce>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Header>
                        產品特色
                        <Col md={24} sm={0} xs={0}>
                            <img src={img_features_pet} alt='img_features_pet' style={{ width: '185px', position: 'absolute', bottom: 0, right: '-235px' }} />
                        </Col>
                    </Header>
                </div>
                <CarouselWrapper>
                    <Col md={24} sm={0} xs={0}>
                    <Slider
                        slidesToShow={2}
                        slidesToScroll={1}
                        infinite={true}
                        dots={false}
                        prevArrow={<PrevArrow/>}
                        nextArrow={<NextArrow/>}
                    >
                        <CarouselItem>
                            <img src={img_features_01} alt='img_features_01' style={{ width: '80%' }} />
                            <ItemHeader>創新 AI 動作賽事</ItemHeader>
                        </CarouselItem>
                        <CarouselItem>
                            <img src={img_features_02} alt='img_features_02' style={{ width: '80%' }} />
                            <ItemHeader>經典步行運動賽事</ItemHeader>
                        </CarouselItem>
                        <CarouselItem>
                            <img src={img_features_03} alt='img_features_03' style={{ width: '80%' }} />
                            <ItemHeader>專屬後台掌握數據</ItemHeader>
                        </CarouselItem>
                        <CarouselItem>
                            <img src={img_features_04} alt='img_features_04' style={{ width: '80%' }} />
                            <ItemHeader>簡易賽事建立流程</ItemHeader>
                        </CarouselItem>
                        <CarouselItem>
                            <img src={img_features_05} alt='img_features_05' style={{ width: '80%' }} />
                            <ItemHeader>一鍵產出ESG報告</ItemHeader>
                        </CarouselItem>
                    </Slider>
                    </Col>
                    <Col md={0} sm={24} xs={24}>
                    <Slider
                        slidesToShow={1}
                        slidesToScroll={1}
                        infinite={true}
                        dots={false}
                        prevArrow={<PrevArrow/>}
                        nextArrow={<NextArrow/>}
                    >
                        <CarouselItem>
                            <img src={img_features_01} alt='img_features_01' style={{ width: '80%' }} />
                            <ItemHeader>創新 AI 動作賽事</ItemHeader>
                        </CarouselItem>
                        <CarouselItem>
                            <img src={img_features_02} alt='img_features_02' style={{ width: '80%' }} />
                            <ItemHeader>經典步行運動賽事</ItemHeader>
                        </CarouselItem>
                        <CarouselItem>
                            <img src={img_features_03} alt='img_features_03' style={{ width: '80%' }} />
                            <ItemHeader>專屬後台掌握數據</ItemHeader>
                        </CarouselItem>
                        <CarouselItem>
                            <img src={img_features_04} alt='img_features_04' style={{ width: '80%' }} />
                            <ItemHeader>簡易賽事建立流程</ItemHeader>
                        </CarouselItem>
                        <CarouselItem>
                            <img src={img_features_05} alt='img_features_05' style={{ width: '80%' }} />
                            <ItemHeader>一鍵產出ESG報告</ItemHeader>
                        </CarouselItem>
                    </Slider>
                    </Col>
                </CarouselWrapper>
                <Row style={{ display: 'flex', justifyContent: 'center' }}>
                    <ConsultButton />
                </Row>
            </ScrollAnimation>
            <ScrollAnimation animateIn='fadeIn' animateOnce>
                <DownloadWrapper>
                    <DownloadContent md={12} sm={24} xs={24}>
                        <img src={img_app_icon} alt='img_app_icon' style={{ width: '120px' }} />
                        <div>下載 Workute APP，立即體驗</div>
                        <Row>
                            <Col md={12} sm={12} xs={24}>
                                <Link newTab href={IOS_DOWNLOAD_URL} style={{ display: 'flex', justifyContent: 'center', margin: '10px 0' }}>
                                    <img src={img_download_ios} alt='img_download_ios' style={{ width: '85%' }} />
                                </Link>
                            </Col>
                            <Col md={12} sm={12} xs={24}>
                                <Link newTab href={ANDROID_DOWNLOAD_URL} style={{ display: 'flex', justifyContent: 'center', margin: '10px 0' }}>
                                    <img src={img_download_android} alt='img_download_android' style={{ width: '85%' }} />
                                </Link>
                            </Col>
                        </Row>
                    </DownloadContent>
                    <DownloadContent md={12} sm={24} xs={24}>
                        <img src={img_download_pet} alt='img_download_pet' style={{ width: '100%' }} />
                    </DownloadContent>
                </DownloadWrapper>
            </ScrollAnimation>
        </FeatureWrapper>
    );
};

export default Feature;
